module.exports = __webpack_public_path__ + "images/41d5495d0b23cb070aa19a5e2e4c6f41.svg";